import { render, staticRenderFns } from "./customColumns.vue?vue&type=template&id=73e22268&scoped=true"
import script from "./customColumns.vue?vue&type=script&lang=js"
export * from "./customColumns.vue?vue&type=script&lang=js"
import style0 from "./customColumns.vue?vue&type=style&index=0&id=73e22268&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e22268",
  null
  
)

export default component.exports